"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _TextButton = require("../TextButton");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTextButton = (0, _material.styled)(_TextButton.TextButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "open";
  }
})(function (_ref) {
  var theme = _ref.theme,
      open = _ref.open;
  return {
    borderColor: open ? theme.palette.primary.main : undefined,
    color: open ? theme.palette.primary.main : undefined
  };
});
var StyledMenu = (0, _material.styled)(_material.Menu)(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _defineProperty2.default)({}, "& .".concat(_utilities.classes.components.MuiPaper.root), {
    borderRadius: "3px",
    padding: "".concat(theme.spacing(2), " 0"),
    width: "12rem"
  });
});

var MenuButton = function MenuButton(_ref4) {
  var _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
      _ref4$open = _ref4.open,
      open = _ref4$open === void 0 ? false : _ref4$open,
      label = _ref4.label,
      onClick = _ref4.onClick,
      onClose = _ref4.onClose,
      TextButtonProps = _ref4.TextButtonProps,
      MenuProps = _ref4.MenuProps,
      dataCy = _ref4["data-cy"],
      children = _ref4.children;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  (0, _react.useEffect)(function () {
    setAnchorEl(open ? ref.current : null);
  }, [open]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextButton, _objectSpread({
      disabled: disabled,
      iconRight: open ? "caret-up" : "caret-down",
      label: label,
      onClick: onClick,
      open: open,
      ref: ref,
      variant: "outlined",
      "data-cy": dataCy
    }, TextButtonProps)), anchorEl && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMenu, _objectSpread(_objectSpread({
      anchorEl: anchorEl,
      anchorOrigin: {
        horizontal: "right",
        vertical: "bottom"
      },
      elevation: 2,
      onClose: onClose,
      open: open,
      transformOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      variant: "menu"
    }, MenuProps), {}, {
      children: children
    }))]
  });
};

var _default = MenuButton;
exports.default = _default;